import { apiClient } from '@/shared/lib/apiClient';
import type { ApiSuccessResponse } from '@super-admin/shared-types';
import type { PortalOverview } from '../types/portalOverview';

export async function fetchPortalOverview(): Promise<PortalOverview> {
  const res = await apiClient.get<ApiSuccessResponse<PortalOverview>>('/api/v1/me/portal-overview');
  return res.data;
}
